/**
 * The languages the site really has, each with its front door. Only languages
 * a person has written and reviewed go here (decided 22 Oct 2026: English and
 * Russian, no machine translation, never a redirect by IP). Feeds the nav
 * language link and the hreflang pair between the two front doors.
 */
export const LANGUAGES = [
  { code: "en", name: "English", url: "https://migrada.eu", path: "/" },
  { code: "ru", name: "Русский", url: "https://migrada.eu/ru", path: "/ru" },
] as const;

/** hreflang for the front doors: each language, and English for everyone else. */
export const FRONT_DOOR_ALTERNATES = [...LANGUAGES.map((l) => ({ hrefLang: l.code, href: l.url })), { hrefLang: "x-default", href: LANGUAGES[0].url }];
